import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib';

import type { TCreditFormState } from 'entities/creditForm';
import type { TUserScoreState } from 'entities/scoring';
import { scoresQueries } from 'entities/scoring';
import type { TUserState } from 'entities/user';
import { isLoggedSelector } from 'entities/user';

import { updateScoreValueSelector } from '../model/updateScoreValue.selector';

export const updateScoreValueThunk = createAsyncThunk<
  void,
  void,
  { state: TCreditFormState & TUserState & TUserScoreState }
>('sendCustomerData/sendCustomerDataThunk', async (_payload, { dispatch, getState }) => {
  const isLoggedIn = isLoggedSelector(getState());
  const { queryData, isNeedUpdateScore } = updateScoreValueSelector(getState());

  if (!isLoggedIn || !isNeedUpdateScore) {
    return;
  }

  try {
    await dispatch(scoresQueries.endpoints.getScores.initiate(queryData)).unwrap();
  } catch (error) {
    sendSentryClientErrorOnce('sendCustomerDataThunk', error);
  }
});
